var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from 'styled-components';
import { memo } from 'react';
import { Container } from './Common';
var HeaderContainer = styled(Container).withConfig({ displayName: "HeaderContainer", componentId: "sc-r09isw" })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-bottom: 16px;\n  padding: 24px 32px 16px 32px;\n\n  box-shadow: 0px 16px 16px -16px rgba(0, 0, 0, 0.1);\n"], ["\n  margin-bottom: 16px;\n  padding: 24px 32px 16px 32px;\n\n  box-shadow: 0px 16px 16px -16px rgba(0, 0, 0, 0.1);\n"])));
var Cell = styled.div.withConfig({ displayName: "Cell", componentId: "sc-3580f7" })(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n\n  color: ", ";\n  font-family: 'Noto Sans', sans-serif;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 16px;\n  letter-spacing: 0.6px;\n  text-transform: uppercase;\n"], ["\n  display: flex;\n\n  color: ", ";\n  font-family: 'Noto Sans', sans-serif;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 16px;\n  letter-spacing: 0.6px;\n  text-transform: uppercase;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.black10;
});
var Header = memo(function (_a) {
    var columns = _a.columns;
    return (_jsx(HeaderContainer, { children: columns.map(function (_a) {
            var id = _a.id, name = _a.name;
            return (_jsx(Cell, { children: name }, id));
        }) }, void 0));
});
export { Header };
var templateObject_1, templateObject_2;
